import { Pipe, PipeTransform, inject } from '@angular/core';
import { FilterOperatorToLabel } from '../../constants';
import { FilterOperator } from '@vendasta/crm';
import { GalaxyFilterOperator } from '@vendasta/galaxy/filter/chips';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'operatorName' })
export class OperatorNamePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(value?: FilterOperator | GalaxyFilterOperator): string {
    if (!value) {
      return '';
    }
    const key = FilterOperatorToLabel[value];
    return key ? this.translateService.instant(key) : String(value);
  }
}
